import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./eventsReport.css";
import RightContainer from "../../components/RightContainer.js";
import DonutChartEvent from "./DonutChartEvent";
import BarChartEvent from "./BarChartEvent";
import MapComponent from "../../components/Reports.jsx/EventMap.jsx";
import Navbar from "../Navbar.js";
import Header from "../HeaderAdmin.js";
import Submenu from "../Submenu.js";
import CircularProgress from "@mui/material/CircularProgress";
import view from "../../images/view.png";
import {
  MLT_USERS, EVENT_ASSOCIATE_URL, COUNTRY_URL, EVENT_TYPE_URL, EVENT_STATUS_URL, EVENT_FORMAT_URL, SITE_DETAILS_URL, FAMILY_USERS,
  EVENT_CHART_FAMILY_URL, EVENT_CHART_YEAR_URL, EVENT_CHART_STATUS_URL, EVENT_CHART_VISITS_URL, EVENT_DETAILS_FILTER_URL, EVENT_TYPE_DONUT_URL
} from "../ApiDetails.js"

const EventsReport = () => {
  const [sortBy, setSortBy] = useState("Newest");
  const [reportsData, setReportsData] = useState([]);
  const [barGraphData, setBarGraphData] = useState([]);
  const [barGraphValue, setBarGraphValue] = useState([]);
  const [donutChartData, setDonutChartData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const navigate = useNavigate();

  const pagesToShow = 4;
  const [isLoading, setIsLoading] = useState(false);
  const [mltUserMembers, setMltUserMembers] = useState([]);
  const [segment, setSegment] = useState([]);
  const [countryFilters, setCountryFilters] = useState([]);
  const [filteredEventDates, setFilteredEventDates] = useState([]);
  const [siteCodes, setSiteCodes] = useState([]);
  const [famMem, setFamMem] = useState([]);
  const [eventStatusFilters, setEventStatusFilters] = useState([]);
  const [eventTypeFilters, setEventTypeFilters] = useState([]);
  const [eventFormatFilters, setEventFormatFilters] = useState([]);

  // To set dropdown values 
  const [reportsFilter, setReportsFilter] = useState({
    selectedSegment: "All",
    selectedCountry: "All",
    selectedSite: "All",
    selectedfamMem: "All",
    selectedmltMem: "All",
    selectedStatus: "All",
    selectedEventType: "All",
    selectedEventFormat: "All",
    startDate: "",
    endDate: "",
    graphDropdownValue: "family",
    reRender: "no",

  });
  const [eventCount, setEventCount] = useState(0);
  const [eventCountAssociates, setAssociatesEventCount] = useState(0);
  const [navBarMltValue, setNavBarMltValue] = useState(false);

  const element = document.getElementById("navBarMltValue");
  if (element) {
    element.addEventListener("change", () => {
      setNavBarMltValue(element.checked);
    });
  }

  // fetching data of dropdown value
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [
          mltUserResponse,
          segmentResponse,
          countryResponse,
          eventTypeResponse,
          eventStatusResponse,
          eventFormatResponse,
        ] = await Promise.all([
          axios.get(MLT_USERS),
          axios.get(EVENT_ASSOCIATE_URL),
          axios.get(COUNTRY_URL),
          axios.get(EVENT_TYPE_URL),
          axios.get(EVENT_STATUS_URL),
          axios.get(EVENT_FORMAT_URL),
        ]);
        setMltUserMembers(mltUserResponse.data);
        setSegment(segmentResponse.data);
        setCountryFilters(countryResponse.data);
        setEventTypeFilters(eventTypeResponse.data);
        setEventStatusFilters(eventStatusResponse.data);
        setEventFormatFilters(eventFormatResponse.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);


  // fetching dropdown value for site dropdown and also getting co-ordinates for map.
  useEffect(() => {
    const fetchSiteCodes = async () => {
      try {
        const response = await axios.get(SITE_DETAILS_URL);

        const siteData = response.data
          .map((site) => ({
            name: (site.site_code + " - " + (site.unit!=="" ? site.unit : "Offsite events")) || "Unknown",
            lat: site.latitude ? parseFloat(site.latitude) : null,
            lng: site.longitude ? parseFloat(site.longitude) : null,
          }))
          .sort((a, b) => a.name.localeCompare(b.name));

        setSiteCodes(siteData);
      } catch (error) {
        console.error("Error fetching site codes:", error);
      }
    };

    fetchSiteCodes();
  }, []);
  // fetching the dropdown values for family member dropdown
  useEffect(() => {
    const fetchFamilyMembers = async () => {
      try {
        const response = await axios.get(FAMILY_USERS);
        setFamMem(response.data);
      } catch (error) {
        console.error("Error fetching family members:", error);
      }
    };
    fetchFamilyMembers();
  }, []);

  // BarGraph dropdown filteration according to family, status, year, most and least visited site.
  useEffect(() => {
    const directBargraphFilter = async () => {
      try {

        const {
          selectedSegment,
          selectedCountry,
          selectedSite,
          selectedfamMem,
          selectedmltMem,
          selectedStatus,
          selectedEventType,
          selectedEventFormat,
          startDate,
          endDate,
          graphDropdownValue,
        } = reportsFilter;

        // Initialize URLSearchParams object
        const filterParams = new URLSearchParams();

        // Append parameters only if they are not "All" or empty
        if (selectedSegment && selectedSegment !== "All") {
          filterParams.append("Segment", selectedSegment);
        }
        if (selectedCountry && selectedCountry !== "All") {
          filterParams.append("Country", selectedCountry);
        }
        if (selectedSite && selectedSite !== "All") {
          filterParams.append("Site", selectedSite.split(" ")[0]);
        }
        if (navBarMltValue) {
          if (selectedmltMem && selectedmltMem !== "All") {
            filterParams.append("Member", selectedmltMem);
          }
        } else {
          if (selectedfamMem && selectedfamMem !== "All") {
            filterParams.append("Member", selectedfamMem);
          }
        }
        if (selectedStatus && selectedStatus !== "All") {
          filterParams.append("Status", selectedStatus);
        }
        if (selectedEventType && selectedEventType !== "All") {
          filterParams.append("Type", selectedEventType);
        }
        if (selectedEventFormat && selectedEventFormat !== "All") {
          filterParams.append("Format", selectedEventFormat);
        }
        if (startDate) {
          filterParams.append("StartDate", startDate);
        }
        if (endDate) {
          filterParams.append("EndDate", endDate);
        }
        filterParams.append("MLTSwitch", navBarMltValue);


        if (graphDropdownValue && graphDropdownValue === "family") {
          const apiUrl = `${EVENT_CHART_FAMILY_URL}${filterParams.toString() ? `?${filterParams.toString()}` : ""}`;
          const result = await axios.get(apiUrl);
          setBarGraphData(result.data)
        }
        if (graphDropdownValue && graphDropdownValue === "status") {
          const apiUrl = `${EVENT_CHART_STATUS_URL}${filterParams.toString() ? `?${filterParams.toString()}` : ""}`;
          const result = await axios.get(apiUrl);
          setBarGraphData(result.data)
        }
        if (graphDropdownValue && graphDropdownValue === "years") {
          const apiUrl = `${EVENT_CHART_YEAR_URL}${filterParams.toString() ? `?${filterParams.toString()}` : ""}`;
          const result = await axios.get(apiUrl);
          setBarGraphData(result.data)
        }
        if (graphDropdownValue && graphDropdownValue === "most") {
          const apiUrl = `${EVENT_CHART_VISITS_URL}${filterParams.toString() ? `?${filterParams.toString()}` : ""}`;
          const result = await axios.get(apiUrl);
          setBarGraphData(result.data)
        }
        if (graphDropdownValue && graphDropdownValue === "least") {
          const apiUrl = `${EVENT_CHART_VISITS_URL}${filterParams.toString() ? `?${filterParams.toString()}` : ""}`;
          const result = await axios.get(apiUrl);
          setBarGraphData(result.data)
        }
      } catch (error) {
        console.error("Error while fetching Graph data:", error);
      }
    };

    directBargraphFilter();

  }, [reportsFilter.graphDropdownValue, reportsFilter.reRender, navBarMltValue]);

  // Initally fetching and setting the values when page gets open first time.
  useEffect(() => {
    const initialFetch = async () => {
      try {

        const filterParams = new URLSearchParams();
        filterParams.append("MLTSwitch", navBarMltValue);

        const response = await axios.get(`${EVENT_DETAILS_FILTER_URL}${filterParams.toString() ? `?${filterParams.toString()}` : ""}`);
        setReportsData(response.data);
        setEventCount(response.data.length);


        const donutResponse = await axios.get(`${EVENT_TYPE_DONUT_URL}${filterParams.toString() ? `?${filterParams.toString()}` : ""}`);
        setDonutChartData(donutResponse.data);

        let associateCount = 0;
        response.data.forEach((item) => {
          associateCount += item.totalAttendees ? item.totalAttendees : 0;
        });

        setAssociatesEventCount(associateCount);

        const filteredDates = response.data
          .map((item) => ({
            eventDate: item.eventDate
              ? new Date(item.eventDate).toLocaleString("en-US", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: false
              }).replace(" ", ", ")
              : null,
            eventStatus: item.eventStatus || "Unknown",
            requestedBy: item.requestedBy || "N/A",
            createdDate: item.createdDate,
            eventEndDate: item.eventEndDate
              ? new Date(item.eventEndDate).toLocaleString("en-US", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: false
              }).replace(" ", ", ")
              : null,
            eventTitle: item.eventTitle || "No Title",
          }))
          .filter(
            (eventObj) =>
              eventObj.eventDate &&
              !isNaN(new Date(eventObj.eventDate).getTime()) &&
              eventObj.eventEndDate &&
              !isNaN(new Date(eventObj.eventEndDate).getTime())
          );

        setFilteredEventDates(filteredDates);




      } catch (error) {
        console.error("Error while fetching initial data:", error);
      }
    };

    initialFetch();
  }, [reportsFilter.reRender, navBarMltValue]);

  // Apply Filter button logic
  const handleApplyFilterClick = async () => {
    setIsLoading(true);
    try {
      const {
        selectedSegment,
        selectedCountry,
        selectedSite,
        selectedfamMem,
        selectedmltMem,
        selectedStatus,
        selectedEventType,
        selectedEventFormat,
        startDate,
        endDate,
        graphDropdownValue,
      } = reportsFilter;

      // Initialize URLSearchParams object
      const filterParams = new URLSearchParams();

      // Append parameters only if they are not "All" or empty
      if (selectedSegment && selectedSegment !== "All") {
        filterParams.append("Segment", selectedSegment);
      }
      if (selectedCountry && selectedCountry !== "All") {
        filterParams.append("Country", selectedCountry);
      }
      if (selectedSite && selectedSite !== "All") {
        filterParams.append("Site", selectedSite.split(" ")[0]);
      }
      if (navBarMltValue) {
        if (selectedmltMem && selectedmltMem !== "All") {
          filterParams.append("Member", selectedmltMem);
        }
      } else {
        if (selectedfamMem && selectedfamMem !== "All") {
          filterParams.append("Member", selectedfamMem);
        }
      }
      if (selectedStatus && selectedStatus !== "All") {
        filterParams.append("Status", selectedStatus);
      }
      if (selectedEventType && selectedEventType !== "All") {
        filterParams.append("Type", selectedEventType);
      }
      if (selectedEventFormat && selectedEventFormat !== "All") {
        filterParams.append("Format", selectedEventFormat);
      }
      if (startDate) {
        filterParams.append("StartDate", startDate);
      }
      if (endDate) {
        filterParams.append("EndDate", endDate);
      }
      filterParams.append("MLTSwitch", navBarMltValue);


      // Construct the full API URL with or without query parameters
      const apiUrl = `${EVENT_DETAILS_FILTER_URL}${filterParams.toString() ? `?${filterParams.toString()}` : ""}`;

      // setting the donut data
      const donutApiUrl = `${EVENT_TYPE_DONUT_URL}${filterParams.toString() ? `?${filterParams.toString()}` : ""}`;
      const donutResponse = await axios.get(donutApiUrl);
      setDonutChartData(donutResponse.data);


      if (graphDropdownValue && graphDropdownValue === "family") {
        const apiUrl = `${EVENT_CHART_FAMILY_URL}${filterParams.toString() ? `?${filterParams.toString()}` : ""}`;
        const result = await axios.get(apiUrl);
        setBarGraphData(result.data)
      }
      if (graphDropdownValue && graphDropdownValue === "status") {
        const apiUrl = `${EVENT_CHART_STATUS_URL}${filterParams.toString() ? `?${filterParams.toString()}` : ""}`;
        const result = await axios.get(apiUrl);
        setBarGraphData(result.data)
      }
      if (graphDropdownValue && graphDropdownValue === "years") {
        const apiUrl = `${EVENT_CHART_YEAR_URL}${filterParams.toString() ? `?${filterParams.toString()}` : ""}`;
        const result = await axios.get(apiUrl);
        setBarGraphData(result.data)
      }
      if (graphDropdownValue && graphDropdownValue === "most") {
        const apiUrl = `${EVENT_CHART_VISITS_URL}${filterParams.toString() ? `?${filterParams.toString()}` : ""}`;
        const result = await axios.get(apiUrl);
        setBarGraphData(result.data)
      }
      if (graphDropdownValue && graphDropdownValue === "least") {
        const apiUrl = `${EVENT_CHART_VISITS_URL}${filterParams.toString() ? `?${filterParams.toString()}` : ""}`;
        const result = await axios.get(apiUrl);
        setBarGraphData(result.data)
      }

      const response = await axios.get(apiUrl);

      // Update the state with the response data
      setReportsData(response.data);
      setEventCount(response.data.length);

      // Calculate and update the associates event count
      let associateCount = 0;
      response.data.forEach((item) => {
        associateCount += item.totalAttendees ? item.totalAttendees : 0;
      });

      setAssociatesEventCount(associateCount);

      // Calender data
      const filteredDates = response.data
        .map((item) => ({
          eventDate: item.eventDate
            ? new Date(item.eventDate).toLocaleString("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: false
            }).replace(" ", ", ")
            : null,
          eventStatus: item.eventStatus || "Unknown",
          eventEndDate: item.eventEndDate
            ? new Date(item.eventEndDate).toLocaleString("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: false
            }).replace(" ", ", ")
            : null,
          eventTitle: item.eventTitle || "No Title",
        }))
        .filter(
          (eventObj) =>
            eventObj.eventDate &&
            !isNaN(new Date(eventObj.eventDate).getTime()) &&
            eventObj.eventEndDate &&
            !isNaN(new Date(eventObj.eventEndDate).getTime())
        );

      setFilteredEventDates(filteredDates);
      paginate(1);
    } catch (error) {
      console.error("Error fetching filtered event details:", error);
    } finally {
      setIsLoading(false); // Set loading to false after the fetch is complete
    }
  };

  // Clear All button logic
  const handleClearAllFilters = () => {
    setReportsFilter((prevState) => ({
      ...prevState,
      selectedSegment: "All",
      selectedCountry: "All",
      selectedSite: "All",
      selectedfamMem: "All",
      selectedmltMem: "All",
      selectedStatus: "All",
      selectedEventType: "All",
      selectedEventFormat: "All",
      startDate: "",
      endDate: "",
      graphDropdownValue: "family",
      reRender: prevState.reRender === "yes" ? "no" : "yes", // Toggle reRender value
    }));
    setReportsData([]);
    setEventCount(0);
    setAssociatesEventCount(0);
    setFilteredEventDates([]);
    paginate(1);
  };

  // Pagination logic
  const totalPages = Math.ceil(reportsData.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = reportsData.sort(function(a, b) {
    if (sortBy==="Newest") return new Date(b.eventDate) - new Date(a.eventDate);
                      else return new Date(a.eventDate)- new Date(b.eventDate);
  }).slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    if (pageNumber < 1) {
      pageNumber = 1;
    } else if (pageNumber > totalPages) {
      pageNumber = totalPages;
    }
    setCurrentPage(pageNumber);
  };

  const pageNumbers = [];
  for (
    let i = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
    i <= Math.min(totalPages, currentPage + Math.floor(pagesToShow / 2));
    i++
  ) {
    pageNumbers.push(i);
  }

  useEffect(() => {

    var processedData = null;
    if (reportsFilter.graphDropdownValue === "year") {

      processedData = barGraphData
        .sort((a, b) => {
          // If sorting by year, arrange in ascending order
          if (/^\d{4}$/.test(a.associatesCategory)) {
            return parseInt(a.associatesCategory) - parseInt(b.associatesCategory);
          }
          // Otherwise, arrange by associateCount in descending order
          return b.associateCount - a.associateCount;
        })
        .slice(0, /^\d{4}$/.test(barGraphData[0].associatesCategory) ? 10 : 8) // Limit to top 10 if year, otherwise top 8
        .map((item) => ({
          x: item.associatesCategory,
          y: item.associateCount,
        }));
    } else {

      if (reportsFilter.graphDropdownValue === "most") {
        processedData = barGraphData
          .sort((a, b) => b.associateCount - a.associateCount)
          .slice(0, 10)
          .map((item) => ({
            x: item.associatesCategory,
            y: item.associateCount
          }));
      } else {

        if (reportsFilter.graphDropdownValue === "least") {
          processedData = barGraphData
            .sort((a, b) => a.associateCount - b.associateCount)
            .slice(0, 10)
            .map((item) => ({
              x: item.associatesCategory,
              y: item.associateCount
            }));
        } else {

          processedData = barGraphData
            .sort((a, b) => b.associateCount - a.associateCount) // Sort by eventcount in descending order
            .map((item) => ({
              x: item.associatesCategory,
              y: item.associateCount
            }));
        }
      }
    }
    setBarGraphValue(processedData);
  }, [barGraphData]);

  // sending to Event Detials Viewer page
  const handleEventview = (event) => {
    if (event.id) {
      const url = `/GetDetailAdmin/${event.eventId}`;
      navigate(url);
    }
  };

  return (
    <div>
      <Header />
      <div className="reportsContainerPadding">
        <Navbar />
        <div className="single-card-container">
          <div className="cards submenuContainer">
            <Submenu reportsData={reportsData} eventCount={eventCount} currentItems={currentItems} />
          </div>
        </div>

        <div
          style={{
            filter: isLoading ? "blur(2px)" : "none",
            transition: "filter 0.3s ease",
          }}
        >
          <div className="single-card-container filter">
            <div className="cards">
              <div className="row">
                <div className="d-flex bd-highlight eventReportFiltersContainer align-items-center">
                  <div className="p-2 flex-fill bd-highlight text-center">
                    <h4 className="reportTitle mt-4">FILTERS</h4>
                  </div>
                  <div className="p-2 col-10 d-flex align-content-start flex-wrap">
                    <div className="col-12">
                      <div className="row eventReportFiltersSpacing">
                        <div className="col">
                          <div className="input-group mb-0">
                            <label
                              className="input-group-text input-group-text-custom"
                              htmlFor="segment"
                            >
                              SEGMENT
                            </label>
                            <select
                              className="form-control-custom rounded form-select"
                              aria-label="Segment"
                              id="segment"
                              value={reportsFilter.selectedSegment}
                              onChange={(e) => {
                                setReportsFilter({
                                  ...reportsFilter,
                                  selectedSegment: e.target.value,
                                });
                              }}
                            >
                              <option value="All">All</option>
                              {segment.length > 0 &&
                                segment.map((segmentName, index) => (
                                  <option key={index} value={segmentName}>
                                    {segmentName}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>
                        <div className="col">
                          <div className="input-group mb-0">
                            <label
                              className="input-group-text input-group-text-custom"
                              htmlFor="country"
                            >
                              COUNTRY
                            </label>
                            <select
                              className="form-control-custom rounded form-select"
                              aria-label="Country"
                              id="country"
                              value={reportsFilter.selectedCountry} // Bind value to state
                              onChange={(e) => {
                                setReportsFilter({
                                  ...reportsFilter,
                                  selectedCountry: e.target.value,
                                });
                              }}
                            >
                              <option value="All">All</option>
                              {countryFilters.length > 0 &&
                                countryFilters.map((countryName, index) => (
                                  <option key={index} value={countryName}>
                                    {countryName}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>
                        <div className="col">
                          <div className="input-group mb-0">
                            <label
                              className="input-group-text input-group-text-custom"
                              htmlFor="site"
                            >
                              SITE CODE
                            </label>
                            <select
                              className="form-control-custom rounded form-select"
                              aria-label="Site"
                              id="site"
                              value={reportsFilter.selectedSite} // Bind value to state
                              onChange={(e) => {
                                setReportsFilter({
                                  ...reportsFilter,
                                  selectedSite: e.target.value,
                                });
                              }}
                            >
                              <option value="All">All</option>
                              {siteCodes.length > 0 &&
                                siteCodes.map((site, index) => (
                                  <option key={index} value={site.name}>
                                    {site.name}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>
                        <div className="col">
                          <div className="input-group mb-0">
                            <label
                              className="input-group-text input-group-text-custom"
                              htmlFor={navBarMltValue ? "mltMem" : "famMem"}
                            >
                              {navBarMltValue ? "MLT MEMBERS" : "FAMILY MEMBERS"}
                            </label>
                            <select
                              className="form-control-custom rounded form-select"
                              aria-label={navBarMltValue ? "mltMem" : "famMem"}
                              id={navBarMltValue ? "mltMem" : "famMem"}
                              value={
                                navBarMltValue
                                  ? reportsFilter.selectedmltMem
                                  : reportsFilter.selectedfamMem
                              } // Corrected value binding
                              onChange={(e) => {
                                setReportsFilter({
                                  ...reportsFilter,
                                  [navBarMltValue ? "selectedmltMem" : "selectedfamMem"]: e.target.value, // Corrected state update
                                });
                              }}
                            >
                              <option value="All">All</option>
                              {(navBarMltValue ? mltUserMembers : famMem).map((memName, index) => (
                                // TODO: Switch to user.ID if possible.
                                <option key={index} value={memName.fullname}>
                                  {memName.fullname}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="col">
                          <div className="input-group mb-0">
                            <label
                              className="input-group-text input-group-text-custom"
                              htmlFor="status"
                            >
                              STATUS
                            </label>
                            <select
                              className="form-control-custom rounded form-select"
                              aria-label="Status"
                              id="status"
                              value={reportsFilter.selectedStatus} // Bind value to state
                              onChange={(e) => {
                                setReportsFilter({
                                  ...reportsFilter,
                                  selectedStatus: e.target.value,
                                });
                              }}
                            >
                              <option value="All">All</option>
                              {eventStatusFilters.length > 0 &&
                                eventStatusFilters.map((statusName, index) => (
                                  <option key={index} value={statusName}>
                                    {statusName}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="row mt-4 eventReportFiltersSpacing">
                        <div className="col">
                          <div className="input-group mb-0">
                            <label
                              className="input-group-text input-group-text-custom"
                              htmlFor="eventType"
                            >
                              EVENT TYPE
                            </label>
                            <select
                              className="form-control-custom rounded form-select"
                              aria-label="Event Type"
                              id="eventType"
                              value={reportsFilter.selectedEventType} // Bind value to state
                              onChange={(e) => {
                                setReportsFilter({
                                  ...reportsFilter,
                                  selectedEventType: e.target.value,
                                });
                              }}
                            >
                              <option value="All">All</option>
                              {eventTypeFilters.length > 0 &&
                                eventTypeFilters.map((eventName, index) => (
                                  <option key={index} value={eventName}>
                                    {eventName}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>
                        <div className="col">
                          <div className="input-group mb-0">
                            <label
                              className="input-group-text input-group-text-custom"
                              htmlFor="eventFormat"
                            >
                              EVENT FORMAT
                            </label>
                            <select
                              className="form-control-custom rounded form-select"
                              aria-label="Event Format"
                              id="eventFormat"
                              value={reportsFilter.selectedEventFormat} // Bind value to state
                              onChange={(e) => {
                                setReportsFilter({
                                  ...reportsFilter,
                                  selectedEventFormat: e.target.value,
                                });
                              }}
                            >
                              <option value="All">All</option>
                              {eventFormatFilters.length > 0 &&
                                eventFormatFilters.map((formatName, index) => (
                                  <option key={index} value={formatName}>
                                    {formatName}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>
                        <div className="col">
                          <div className="input-group mb-0">
                            <label
                              className="input-group-text input-group-text-custom"
                              htmlFor="startDate"
                            >
                              START DATE
                            </label>
                            <input
                              type="date"
                              className="form-control-custom rounded form-select text-cursor"
                              id="startDate"
                              value={reportsFilter.startDate} // Bind value to state
                              onChange={(e) => {
                                setReportsFilter({
                                  ...reportsFilter,
                                  startDate: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                        <div className="col">
                          <div className="input-group mb-0">
                            <label
                              className="input-group-text input-group-text-custom"
                              htmlFor="endDate"
                            >
                              END DATE
                            </label>
                            <input
                              type="date"
                              className="form-control-custom rounded form-select text-cursor"
                              id="endDate"
                              value={reportsFilter.endDate} // Bind value to state
                              onChange={(e) => {
                                setReportsFilter({
                                  ...reportsFilter,
                                  endDate: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                        <div className="col">
                            <div className="mb-3">
                                <div className="input-group mb-0">
                                    <label
                                        className="input-group-text input-group-text-custom"
                                        htmlFor="sortBy"
                                    >
                                        Sort By
                                    </label>
                                    <select
                                        className="form-control-custom rounded form-select"
                                        aria-label="Sort By"
                                        id="sortBy"
                                        value={sortBy}
                                        onChange={(e) => setSortBy(e.target.value)}
                                    >
                                        <option value="Newest">Newest</option>
                                        <option value="Oldest">Oldest</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-1 text-end d-flex flex-column align-items-end justify-content-center eventReportsFiltersButtons">
                    <button
                      className="btn-primary-custom p-1 mt-4"
                      onClick={handleApplyFilterClick}
                    >
                      Apply Filters
                    </button>
                    <button
                      className="btn-secondary-custom"
                      onClick={handleClearAllFilters}
                    >
                      Clear All
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Display Map and Calendar */}
          <div className="container-fluid">
            <div
              className="progress d-flex flex-column"
              style={{ backgroundColor: "#f5f5fb", height: "30%" }}
            >
              <div className="row">
                <div className="col-md-8">
                  <MapComponent reportsData={reportsData} />
                </div>
                <div className="col-md-4">
                  <RightContainer eventDates={filteredEventDates} />
                </div>
              </div>
            </div>
          </div>

          {/* Display filtered results */}
          <div className="card-container">
            <div className="cards">
              <div className="card-header">
                Total Events in Selection: <br /> <span className="card-Count">{eventCount}</span>
              </div>
            </div>
            <div className="cards">
              <div className="card-header">
                Estimate number of associates in selection: <br />
                <span className="card-Count"> {eventCountAssociates}</span>
              </div>
            </div>
          </div>

          {/* Display Donut Chart and Bar Graph */}
          <div className="card-container">
            {/* Donut Chart */}
            <div className="cards">
              <div className="card-header">EVENT BY TYPE</div>
              <div className="donut-container">
                <DonutChartEvent eventData={donutChartData} />
              </div>
            </div>

            {/* Bar Chart */}
            <div className="cards">
              <div className="d-flex justify-content-between align-items-center">
                <div className="card-header">EVENT DATA</div>
                <div className="form-group mb-3">
                  <select
                    className="form-control form-select custom-select chart-dropdown"
                    aria-label="MARS Family"
                    value={reportsFilter.graphDropdownValue}
                    onChange={(e) => {
                      setReportsFilter({
                        ...reportsFilter,
                        graphDropdownValue: e.target.value,
                      });
                    }}
                  >
                    <option value="family">Total events by Member</option>
                    <option value="status">Total events by Status</option>
                    <option value="years">Total events by Years</option>
                    <option value="most">Most visited Sites</option>
                    <option value="least">Least visited Sites</option>
                  </select>
                </div>
              </div>
              <BarChartEvent filteredData={barGraphValue} name="Total Events" />
            </div>
          </div>

          {/* Table for displaying report data */}
          <div className="single-card-container">
            <div className="cards-table">
              <div className="grid-container-events">
                <div className="grid-header-first">SITE</div>
                <div className="grid-header">LOCATION</div>
                <div className="grid-header">DATE</div>
                <div className="grid-header">VISITOR</div>
                <div className="grid-header">EVENT TYPE</div>
                <div className="grid-header">SEGMENT</div>
                <div className="grid-header">FORMAT</div>
                <div className="grid-header">TOUCHES</div>
                <div className="grid-header">OFF SITE</div>
                <div className="grid-header">STATUS</div>
                <div className="grid-header-last">SEE EVENTS</div>
                {currentItems.length > 0 ? (
                  currentItems.map((item, index) => (
                    <React.Fragment key={index}>
                      <div className="grid-item-first">{item.siteCode}</div>
                      <div className="grid-item">{item.eventVenueName!=="" ? item.eventVenueName : item.eventAddress}</div>
                      <div className="grid-item">{new Date(item.eventDate).toLocaleDateString('en-US', {timeZone: 'UTC'})}
                      </div>
                      <div className="grid-item">{item.nameOfMem}</div>
                      <div className="grid-item">{item.eventType}</div>
                      <div className="grid-item">{item.associates}</div>
                      <div className="grid-item">{item.eventFormat}</div>
                      <div className="grid-item">{item.totalAttendees}</div>
                      <div className="grid-item">{item.siteCode === "OFF" ? "YES" : "NO"}</div>
                      <div className="grid-item">{item.eventStatus}</div>
                      <div className="grid-item-last">
                        <button
                          className="btn btn-icon"
                          onClick={() => handleEventview(item)}
                        >
                          <img
                            src={view}
                            alt="Edit"
                            width={24}
                            height={24}
                          />
                        </button>
                      </div>
                    </React.Fragment>
                  ))
                ) : (
                  <div
                    className="grid-item"
                    style={{ gridColumn: "1 / -1", textAlign: "center" }}
                  >
                    No events found
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Pagination */}
          <nav aria-label="Page navigation">
            <ul className="pagination-report justify-content-center">
              <li className={`page-item-report ${currentPage === 1 ? "disabled-report" : ""}`}>
                <button
                  className="page-link-report"
                  onClick={() => paginate(currentPage - 1)}
                >
                  Previous
                </button>
              </li>
              {pageNumbers.map((number) => (
                <li
                  key={number}
                  className={`page-item-report ${number === currentPage ? "active-report" : ""}`}
                >
                  <button onClick={() => paginate(number)} className="page-link-report">
                    {number}
                  </button>
                </li>
              ))}
              <li
                className={`page-item-report ${currentPage === totalPages ? "disabled-report" : ""}`}
              >
                <button
                  className="page-link-report"
                  onClick={() => paginate(currentPage + 1)}
                >
                  Next
                </button>
              </li>
            </ul>
          </nav>

          {isLoading && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(255, 255, 255, 0.1)", // Semi-transparent background
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999, // Ensure the loader is on top of everything
              }}
            >
              <CircularProgress />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EventsReport;
